import {
  Field,
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import React, { useEffect, useRef, useState } from "react";
import ShadowCard from "../../components/common/ShadowCard";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormDatePicker from "../../components/formFields/FormDateField";
import { Button } from "@progress/kendo-react-buttons";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useLocation, useNavigate } from "react-router-dom";
import { RootState } from "../../app/store";
import { LoadingPanel } from "../../components/layout/Loading";
import moment from "moment";
import {
  getKarigarListByProcess,
  getKarigarStock,
} from "../karigar/services/karigar.services";
import { findAllActiveItem } from "../item/services/item.services";
import { findAllActivePurity } from "../purity/services/purity.services";
import { findAllActiveProcess } from "../process/services/process.services";
import GhatReceiptOrderEntryArray from "./BandhaiReceiptOrderEntryArray";
import { findAllActiveUnit } from "../unit/services/unit.services";
import { findAllActiveItemCategory } from "../itemcategory/services/itemcategory.services";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { clearBandhaiReceiptDetail } from "./bandhaiReceiptSlice";
import {
  createBandhaiReceipt,
  getBandhaiReceiptById,
  updateBandhaiReceipt,
} from "./services/bandhaiReceipt.services";
import BandhaiReceiptOrderListArray from "./BandhaiReceiptOrderListArray";
import { PRINT_ACCESS, PROCESS_ID } from "../../_contstants/common";
import { clearKarigarStock } from "../karigar/karigarSlice";
import { IKarigarListByProcess } from "../karigar/karigarModel";
import {
  checkAcessRights,
  formatToIndianCurrencyWithoutSymbol,
  formatWeight,
} from "../../_helper/helper";
import { FaEye } from "react-icons/fa";
import { findAllActiveCharges } from "../charges/services/charges.services";

interface ChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const GhatOrderEntryChangeWatcher: React.FC<ChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const bandhai_receipt_order = formRenderProps.valueGetter(
    "bandhai_receipt_order",
  );

  const karigar_id = formRenderProps.valueGetter("karigar_id");
  // const KarigarList = useAppSelector(
  //   (state) => state.karigar?.KarigarListByProcess
  // );
  const dispatch = useAppDispatch();

  const fetchKarigarStock = async (karigar_id: number) => {
    await dispatch(getKarigarStock(karigar_id));
  };
  useEffect(() => {
    if (karigar_id) {
      fetchKarigarStock(karigar_id);
    }
  }, [karigar_id]);

  // useEffect(() => {
  //   if (karigar_id && KarigarList && KarigarList?.length > 0) {
  //     const selectedKarigar = KarigarList.find(
  //       (karigar) => karigar.karigar_id === karigar_id
  //     );
  //     if (selectedKarigar) {
  //       const wastage = selectedKarigar?.wastage;
  //       formRenderProps.onChange(`karigar_wastage`, {
  //         value: wastage || 0,
  //       });
  //     }
  //   }
  // }, [karigar_id, KarigarList]);

  useEffect(() => {
    if (bandhai_receipt_order && bandhai_receipt_order?.length > 0) {
      bandhai_receipt_order.forEach((receipt_order: any, index: number) => {
        const netWeight =
          receipt_order.gross_weight - receipt_order.stone_weight;
        // const phine = netWeight * ((receipt_order.purity + receipt_order.wastage) / 100);
        formRenderProps.onChange(`bandhai_receipt_order.${index}.net_weight`, {
          value: netWeight,
        });
        // formRenderProps.onChange(`bandhai_receipt_order.${index}.phine`, {
        //   value: phine.toFixed(3),
        // });
      });
    }
  }, [
    bandhai_receipt_order?.map((item: any) => item.gross_weight).join("-"),
    bandhai_receipt_order?.map((item: any) => item.stone_weight).join("-"),
    // bandhai_receipt_order?.map((item: any) => item.purity).join("-"),
    // bandhai_receipt_order?.map((item: any) => item.wastage).join("-"),
  ]);
  return null;
};

const CreateBandhaiReceipt: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const gridRef = useRef<any>(null);

  const loading = useAppSelector((state) => state.bandhaireceipt.loading);

  const KarigarListByProcess = useAppSelector(
    (state) => state.karigar?.KarigarListByProcess,
  );
  const karigarStock = useAppSelector((state) => state.karigar.KarigarStock);
  const BandhaiReceiptDetail = useAppSelector(
    (state: RootState) => state.bandhaireceipt.BandhaiReceiptDetail,
  );
  const BandhaiReceiptOrderSave = useAppSelector(
    (state: RootState) => state.bandhaireceipt.BandhaiReceiptOrderSave,
  );
  const bandhai_receipt_guid = location?.state?.bandhai_receipt_guid;
  const isPrintAccess = checkAcessRights(
    "/" + location.pathname.split("/")[1],
    PRINT_ACCESS,
  );
  const [formKey, setFormKey] = useState(1);
  const today = new Date();
  const maxDate =
    new Date(today.getFullYear(), today.getMonth(), today.getDate()) || null;

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [BandhaiReceiptDetail]);

  const handleFormClose = () => {
    navigate("/bandhaireceipt");
  };

  useEffect(() => {
    dispatch(findAllActiveCharges());
    dispatch(findAllActiveProcess());
    dispatch(getKarigarListByProcess(PROCESS_ID.bandhai));
    dispatch(findAllActivePurity());
    dispatch(findAllActiveItem());
    dispatch(findAllActiveUnit());
    dispatch(findAllActiveItemCategory());
    return () => {
      dispatch(clearBandhaiReceiptDetail());
      dispatch(clearKarigarStock());
    };
  }, []);

  useEffect(() => {
    if (bandhai_receipt_guid) {
      dispatch(getBandhaiReceiptById(bandhai_receipt_guid));
    }
  }, [bandhai_receipt_guid]);

  const handleSubmit = async (values: any) => {
    if (BandhaiReceiptOrderSave) return false;
    // console.log("values", values);
    const formdata = {
      karigar_id: values.karigar_id ? +values.karigar_id : null,
      receipt_date: values.receipt_date
        ? moment(values.receipt_date).format("YYYY-MM-DD")
        : "",
      bandhai_receipt_order: values.bandhai_receipt_order
        ? values.bandhai_receipt_order?.map((order: any) => ({
            id: order.id ? order.id : 0,
            bandhai_issue_id: order.bandhai_issue_id ?? 0,
            order_id: order.order_id,
            item_id: order.item_id,
            item_category_id: order.item_category_id,
            item_description: order.item_description,
            gross_weight: order.gross_weight,
            stone_weight: order.stone_weight,
            net_weight: order.net_weight,
            weight: order.weight,
            purity: order.purity || 0,
            purity_id: order.purity_id || 0,
            wastage: order.wastage || 0,
            phine: order.phine || 0,
            iscaret: order.iscaret,
            isdesign: order.isdesign,
            isgoldcolor: order.isgoldcolor,
            isweight: order.isweight,
            issize: order.issize,
            ispolishcolor: order.ispolishcolor,
            isfinishorder: order.isfinishorder,
            iseverythingasdescription: order.iseverythingasdescription,
            bandhai_charges: order.bandhai_charges,
            approval_items: order.approval_items
              ? order.approval_items
                  ?.filter(
                    (item: any) =>
                      item?.type &&
                      item?.item_id &&
                      item?.weight &&
                      item?.qty &&
                      item?.unit_id,
                  )
                  ?.map((app: any) => ({
                    id: app?.id ? app?.id : 0,
                    IssueDate: app?.IssueDate
                      ? moment(app?.IssueDate).format("YYYY-MM-DD")
                      : null,
                    type: app?.type,
                    item_id: app?.item_id,
                    weight: app?.weight,
                    qty: app?.qty,
                    unit_id: app?.unit_id,
                    return_weight: app?.return_weight,
                    return_qty: app?.return_qty,
                    used_weight: app?.used_weight,
                    used_qty: app?.used_qty,
                    customer_rate: app?.customer_rate,
                    customer_less_weight: app?.customer_less_weight,
                  }))
              : [],
            item_used_by_kariagr: order.item_used_by_kariagr
              ? order.item_used_by_kariagr
                  ?.filter(
                    (item: any) =>
                      item?.item_id &&
                      item?.weight &&
                      item?.qty &&
                      item?.apply_on &&
                      item?.unit_id &&
                      item?.rate,
                  )
                  ?.map((karigar: any) => ({
                    id: karigar?.id ? karigar?.id : 0,
                    item_id: karigar?.item_id,
                    weight: karigar?.weight,
                    qty: karigar?.qty,
                    apply_on: karigar?.apply_on,
                    unit_id: karigar?.unit_id,
                    rate: karigar?.rate,
                    total: karigar?.total,
                    custom_rate: karigar?.custom_rate,
                    customer_less_weight: karigar?.customer_less_weight,
                  }))
              : [],
            bandhai_gold_receive: order.bandhai_gold_receive
              ? order.bandhai_gold_receive.map((item: any) => {
                  return {
                    id: item.id ? item.id : 0,
                    item_id: item.item_id,
                    GhatItemRowNum: item.GhatItemRowNum
                      ? item.GhatItemRowNum
                      : 0,
                    ReceiveDate: item.ReceiveDate
                      ? moment(item.ReceiveDate).format("YYYY-MM-DD")
                      : null,
                    ReceiveWeight: item.ReceiveWeight ? +item.ReceiveWeight : 0,
                    pcs: item.pcs ? +item.pcs : 0,
                  };
                })
              : [],
          }))
        : [],
    };
    // console.log("formdata", formdata);
    if (bandhai_receipt_guid) {
      const editPayload = {
        ...formdata,
        bandhai_receipt_guid: bandhai_receipt_guid,
      };
      try {
        const response = await dispatch(updateBandhaiReceipt(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          if (bandhai_receipt_guid) {
            dispatch(getBandhaiReceiptById(bandhai_receipt_guid));
          }
          navigate("/bandhaireceipt/edit", {
            state: {
              bandhai_receipt_guid: bandhai_receipt_guid,
            },
          });
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    } else {
      try {
        const response = await dispatch(createBandhaiReceipt(formdata));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/bandhaireceipt/edit", {
            state: {
              bandhai_receipt_guid: response.payload.bandhai_receipt_guid,
            },
          });
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    }
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <Form
        onSubmit={handleSubmit}
        key={formKey}
        initialValues={BandhaiReceiptDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <GhatOrderEntryChangeWatcher formRenderProps={formRenderProps} />
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[{ width: "33%" }, { width: "33%" }, { width: "33%" }]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h4>
                    {bandhai_receipt_guid
                      ? "Update Bandhai Receipt"
                      : "Create Bandhai Receipt"}
                  </Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="karigar_id"
                    label="Karigar Name"
                    placeholder="Select Karigar"
                    isAddNew={true}
                    addNewLink="karigar/create"
                    dispatcherFunction={getKarigarListByProcess}
                    dispatcherFunctionPayload={PROCESS_ID.bandhai}
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={KarigarListByProcess?.map(
                      (karigar: IKarigarListByProcess) => {
                        return {
                          value: karigar?.karigar_id,
                          label: `${karigar?.karigar_nick_name || karigar?.karigar_name}`,
                        };
                      },
                    )}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="receipt_date"
                    label="Receipt Date"
                    placeholder="day/month/year"
                    format={"dd/MM/yyyy"}
                    max={maxDate}
                    component={FormDatePicker}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <div className="stock-container">
                    <div className="stock-item">
                      <div className="stock-header">
                        <div
                          className={`indicator-dot amount-dot-${karigarStock.Amount_credit_debit}`}
                        ></div>
                        <Typography.h6 className="stock-label">
                          Amount Balance
                        </Typography.h6>
                      </div>
                      <Typography.h6
                        className={`stock-value amount-value-${karigarStock.Amount_credit_debit}`}
                      >
                        {formatToIndianCurrencyWithoutSymbol(
                          karigarStock.amount || 0,
                        )}{" "}
                        <span
                          style={{
                            fontWeight: "normal",
                            textTransform: "capitalize",
                            fontSize: 16,
                          }}
                        >
                          {karigarStock.Amount_credit_debit}
                        </span>
                      </Typography.h6>
                    </div>

                    <div className="stock-item">
                      <div className="stock-header">
                        <div
                          className={`indicator-dot phine-dot-${karigarStock.phine_credit_debit}`}
                        ></div>
                        <Typography.h6 className="stock-label">
                          Phine (gm) Stock
                        </Typography.h6>
                      </div>
                      <Typography.h6
                        className={`stock-value phine-value-${karigarStock.phine_credit_debit}`}
                      >
                        {formatWeight(karigarStock.phine)}{" "}
                        <span
                          style={{
                            fontWeight: "normal",
                            textTransform: "capitalize",
                            fontSize: 16,
                          }}
                        >
                          {karigarStock.phine_credit_debit}
                        </span>
                      </Typography.h6>
                    </div>
                  </div>
                </GridLayoutItem>
                {/* <GridLayoutItem>
                  <Field
                    id={"IsActive"}
                    name={"isactive"}
                    label={"Status"}
                    component={FormSelectionField}
                    validator={requiredValidator}
                    options={STATUSARRAY?.map((status: any) => {
                      return {
                        value: status.value,
                        label: status.label,
                      };
                    })}
                  />
                </GridLayoutItem> */}
              </GridLayout>
            </ShadowCard>
            <ShadowCard style={{ marginTop: 10, padding: 12 }}>
              {/* THIS IS FOR LISTING */}
              <FieldArray
                formRenderProps={formRenderProps}
                component={BandhaiReceiptOrderListArray}
                name="bandhai_receipt_order"
              />
              {/* THIS IS FOR DIALOG */}
              <FieldArray
                formRenderProps={formRenderProps}
                component={GhatReceiptOrderEntryArray}
                name="bandhai_receipt_order"
              />
              <GridLayoutItem
                colSpan={3}
                style={{
                  textAlign: "end",
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                {isPrintAccess && bandhai_receipt_guid && (
                  <Button
                    type="button"
                    style={{ marginRight: 4 }}
                    fillMode={"solid"}
                    themeColor={"primary"}
                    onClick={() =>
                      window.open(
                        `/bandhaireceipt/${bandhai_receipt_guid}`,
                        "_blank",
                      )
                    }
                  >
                    <FaEye style={{ fontSize: "18" }} /> View Report
                  </Button>
                )}
                <ButtonWithLoading
                  type="submit"
                  label={!bandhai_receipt_guid ? "Create" : "Update"}
                  themeColor={"primary"}
                  fillMode={"solid"}
                  disabled={!formRenderProps.allowSubmit || loading}
                  loading={loading}
                />
                <Button
                  type="button"
                  fillMode={"outline"}
                  themeColor={"primary"}
                  style={{ marginLeft: 4 }}
                  onClick={handleFormClose}
                >
                  Cancel
                </Button>
              </GridLayoutItem>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateBandhaiReceipt;
